import styled from '@emotion/styled';

export default styled('div')`
  box-sizing: border-box;
  padding-left: 32px;
  padding-right: 32px;
`;
